module.exports = __webpack_public_path__ + "img/mouse_scroll.a96bdcdb.svg";